'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var podOrderDetailComponent = exports.podOrderDetailComponent = {
    template: require('./pod-order-detail.html'),
    controllerAs: 'vm',
    bindings: {
        order: '<'
    },
    controller: ["common", "gettextCatalog", function podOrderDetailController(common, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            common.setTitle(gettextCatalog.getString('Verzending') + ' ' + vm.order.number);


        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/pod-order-detail.js
// module id = 865
// module chunks = 0